import { useGetHttp } from "../../http.hook";
import type { ICSVUpload } from "./add-new-csv-favorite-collection.admin.http";

interface IResponse {
  csvLogs: Array<ICSVUpload>;
}

export function useGetCsvLogAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/:favouriteId/csv",
  });
}
